import * as React from 'react';
import { Trans } from '@lingui/macro';

export const linkedBondsElementDetailsLabels = {
  'S_ACC.INT_RATE': () => <Trans>Coupon actuel</Trans>,
  'S_ACC.OBL_END_DATE': () => <Trans>Échéance</Trans>,
  'S_QUOTE.PRICE_CLOSE': () => <Trans>Prix</Trans>,
  'S_MARKET.YIELD': () => <Trans>Rendement (YTM)</Trans>,
  'S_MARKET.QT_MIN': () => <Trans>Coupure</Trans>,
  'C_CURRENCY.CODE': () => <Trans>Devise</Trans>,
  'GES_RAT_VAL_SP.SHORTCUT': () => <Trans>Rating S&P</Trans>,
};
